var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8281 20.5H6.54688C3.3125 20.5 0.6875 17.875 0.6875 14.6406V6.35938C0.6875 3.125 3.3125 0.5 6.54688 0.5H14.8281C18.0625 0.5 20.6875 3.125 20.6875 6.35938V14.6406C20.6875 17.875 18.0625 20.5 14.8281 20.5Z",
    fill: "#007BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.457 8.73047C11.4805 7.75391 9.89844 7.75391 8.92188 8.73047C7.94531 9.70703 7.94531 11.2891 8.92188 12.2656C9.89844 13.2422 11.4805 13.2422 12.457 12.2656L14.2266 14.0352C12.2734 15.9883 9.10938 15.9883 7.15625 14.0352C5.20312 12.082 5.20312 8.91797 7.15625 6.96484C9.10938 5.01172 12.2734 5.01172 14.2266 6.96484L15.5508 5.64063V10.0586H11.1289L12.457 8.73047Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.6875 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.8059779700c7f7aa064d2888073e3f2f.svg";
export { ForwardRef as ReactComponent };